<template>
  <div class="flex flex-col w-11/12 mx-auto shadow-xl mt-10 md:mt-4">
    <router-link :to="pathClassroom+classroom.url"
      class="flex bg-beige-academy-100 items-center p-4 text-base lg:text-xl font-bold">
      {{$t('lesson.with')}} {{ isTeacher ? classroom.student.name : classroom.teacher.name }}
    </router-link>
    <div class="w-full flex justify-between font-sans-serif">
      <div class="flex p-10 border-r-2 border-white text-base lg:text-lg"
      v-if="classroom.bookedLessons.length>0">
        <span>{{$t('lesson.next')}}:</span>
        <span class="font-bold pl-2">{{ dayNext }}</span>
      </div>
      <!--<button class="flex m-10 px-2 py-1 bg-beige-academy-100 rounded transform
      hover:-translate-y-1">
        <download-icon />
        {{$t('lesson.download')}}
      </button>-->
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
// import DownloadIcon from './DownloadIcon.vue';

export default {

  props: ['classroom', 'isTeacher'],

  computed: {
    dayNext() {
      const date = dayjs.tz(this.classroom.bookedLessons[0].slot.start_date, 'UTC');
      return dayjs(date).tz(this.choosenTimezone).format('LL');
    },

    pathClassroom() {
      return this.isTeacher ? '/teacher-dashboard' : '/student-dashboard';
    },
  },
};
</script>
